export default {
	CURRENCIES: 'Currencies',
	TILE_LAYOUTS: 'Tile layouts',
};
